import React, { PureComponent } from "react";
import uuid from "uuid";
import DatePicker from "react-datepicker";

import Input from "../../components/Input";
import MultiInput from "../../components/MultiInput";
import MaskedValidatedInput from "../../components/MaskedValidatedInput";
import DropDown from "../../components/DropDown";
import CheckBox from "../../components/Checkbox";
import {
  required,
  zipCodeValidator,
  integerValidator,
} from "../../validation/validation";
import { extractOnlyDigits } from "../../utils/format";

import { FileComponent } from "./FileComponent";

import "react-datepicker/dist/react-datepicker.css";

export const renderTextBox = (
  requestPropertyName,
  text,
  request,
  updateRequestPropertyCallBack,
  placeholder,
  options = {}
) => {
  return (
    <div className="form-group card-holder">
      <label htmlFor={requestPropertyName}>{text}</label>
      <Input
        value={request[requestPropertyName]}
        type="text"
        id={requestPropertyName}
        name={requestPropertyName}
        onChange={(e) => {
          updateRequestPropertyCallBack(requestPropertyName, e.target.value);
        }}
        validations={[required]}
        field={requestPropertyName}
        placeholder={placeholder}
        ignoreServerValidation={options.ignoreServerValidation}
      />
    </div>
  );
};

export const renderOptionalTextBox = (
  requestPropertyName,
  text,
  request,
  updateRequestPropertyCallBack,
  placeholder
) => {
  return (
    <div className="form-group card-holder">
      <label htmlFor={requestPropertyName}>{text}</label>
      <Input
        value={request[requestPropertyName]}
        type="text"
        id={requestPropertyName}
        name={requestPropertyName}
        onChange={(e) => {
          updateRequestPropertyCallBack(requestPropertyName, e.target.value);
        }}
        field={requestPropertyName}
        placeholder={placeholder}
      />
    </div>
  );
};

export const renderMultiTextBox = (
  requestPropertyName,
  text,
  request,
  updateRequestPropertyCallBack
) => {
  return (
    <div className="form-group card-holder quote-change-multi-text">
      <label htmlFor={requestPropertyName}>{text}</label>
      <MultiInput
        value={request[requestPropertyName]}
        type="text"
        id={requestPropertyName}
        name={requestPropertyName}
        onChange={(e) =>
          updateRequestPropertyCallBack(requestPropertyName, e.target.value)
        }
        validations={[required]}
        field={requestPropertyName}
      />
    </div>
  );
};

export const renderZipCode = (
  requestPropertyName,
  text,
  request,
  updateRequestPropertyCallBack
) => {
  return (
    <div className="form-group card-holder">
      <label htmlFor={requestPropertyName}>{text}</label>
      <MaskedValidatedInput
        value={request[requestPropertyName]}
        type="text"
        mask="11111"
        id={requestPropertyName}
        name={requestPropertyName}
        onBlur={(e) =>
          updateRequestPropertyCallBack(requestPropertyName, e.target.value)
        }
        validations={[required, zipCodeValidator]}
        field={requestPropertyName}
      />
    </div>
  );
};

export const renderDropdown = (
  requestPropertyName,
  text,
  request,
  updateRequestPropertyCallBack,
  listOptions
) => {
  return (
    <div className="form-group card-holder quote-change-dropdown">
      <label htmlFor={requestPropertyName}>{text}</label>
      <DropDown
        value={request[requestPropertyName]}
        type="text"
        listOptions={listOptions}
        id={requestPropertyName}
        name={requestPropertyName}
        placeholder="Select"
        onChange={(e) =>
          updateRequestPropertyCallBack(requestPropertyName, e.target.value)
        }
        validations={[required]}
        field={requestPropertyName}
        style={{ height: "auto" }}
      />
    </div>
  );
};

export const renderOptionalDropdown = (
  requestPropertyName,
  text,
  request,
  updateRequestPropertyCallBack,
  listOptions
) => {
  return (
    <div className="form-group card-holder quote-change-dropdown">
      <label htmlFor={requestPropertyName}>{text}</label>
      <DropDown
        value={request[requestPropertyName]}
        type="text"
        listOptions={listOptions}
        id={requestPropertyName}
        name={requestPropertyName}
        placeholder="Select"
        onChange={(e) =>
          updateRequestPropertyCallBack(requestPropertyName, e.target.value)
        }
        field={requestPropertyName}
        style={{ height: "auto" }}
      />
    </div>
  );
};

export const renderInteger = (
  requestPropertyName,
  text,
  request,
  updateRequestPropertyCallBack,
  placeholder,
  options = {}
) => {
  return (
    <div className="form-group card-holder">
      <label htmlFor={requestPropertyName} style={{ width: "480px" }}>
        {text}
      </label>
      <Input
        value={request[requestPropertyName]}
        type="text"
        id={requestPropertyName}
        name={requestPropertyName}
        onBlur={(e) =>
          updateRequestPropertyCallBack(requestPropertyName, e.target.value)
        }
        placeholder={placeholder}
        validations={[required, integerValidator]}
        field={requestPropertyName}
        ignoreServerValidation={options.ignoreServerValidation}
      />
    </div>
  );
};

export const renderCheckBox = (
  requestPropertyName,
  text,
  request,
  updateRequestPropertyCallBack
) => {
  return (
    <div className="form-group card-holder">
      <label htmlFor={requestPropertyName}>
        <CheckBox
          id={requestPropertyName}
          name={requestPropertyName}
          checked={request[requestPropertyName]}
          onChange={(e) =>
            updateRequestPropertyCallBack(requestPropertyName, e.target.checked)
          }
        />
        {text}
      </label>
    </div>
  );
};

export const renderYesNo = (
  requestPropertyName,
  text,
  request,
  updateRequestPropertyCallBack
) => {
  return (
    <div className="form-group card-holder">
      <label>{text}</label>
      <div>
        {renderRadioButton(
          requestPropertyName,
          "Yes",
          request,
          updateRequestPropertyCallBack,
          true
        )}
        {renderRadioButton(
          requestPropertyName,
          "No",
          request,
          updateRequestPropertyCallBack,
          false
        )}
      </div>
    </div>
  );
};

export const renderExcludeInclude = (
  requestPropertyName,
  text,
  request,
  updateRequestPropertyCallBack
) => {
  return (
    <div className="form-group card-holder">
      <label>{text}</label>
      <div>
        {renderRadioButton(
          requestPropertyName,
          "Exclude",
          request,
          updateRequestPropertyCallBack,
          true
        )}
        {renderRadioButton(
          requestPropertyName,
          "Include",
          request,
          updateRequestPropertyCallBack,
          false
        )}
      </div>
    </div>
  );
};

export const renderAddDeleteButton = (
  text,
  request,
  updateRequestPropertyCallBack
) => {
  return (
    <div className="form-group card-holder">
      <label>{text}</label>
      <div>
        {renderRadioButton(
          "isDeleteRequest",
          "Add",
          request,
          updateRequestPropertyCallBack,
          false
        )}
        {renderRadioButton(
          "isDeleteRequest",
          "Delete",
          request,
          updateRequestPropertyCallBack,
          true
        )}
      </div>
    </div>
  );
};

export const renderMoney = (
  requestPropertyName,
  text,
  request,
  updateRequestPropertyCallBack,
  options = {}
) => {
  const handleOnChange = (e) => {
    updateRequestPropertyCallBack(
      requestPropertyName,
      extractOnlyDigits(e.target.value)
    );
  };

  const formattedValue =
    request[requestPropertyName] &&
    "$" + Number(request[requestPropertyName]).toLocaleString();

  return (
    <div className="form-group card-holder">
      <label htmlFor={requestPropertyName}>{text}</label>
      <Input
        value={formattedValue}
        type="text"
        id={requestPropertyName}
        name={requestPropertyName}
        onChange={handleOnChange}
        validations={[required]}
        field={requestPropertyName}
        ignoreServerValidation={options.ignoreServerValidation}
      />
    </div>
  );
};

export const renderEffectiveDate = (request, updateRequestPropertyCallBack) => {
  return renderDate(
    "effectiveDate",
    "Effective Date For This Request",
    request,
    updateRequestPropertyCallBack
  );
};

export const renderDate = (
  requestPropertyName,
  text,
  request,
  updateRequestPropertyCallBack
) => {
  return (
    <div className="form-group card-holder">
      <label>{text}</label>
      <DatePicker
        className="quote-change-date-picker"
        selected={request[requestPropertyName]}
        onChange={(date) => {
          if (date === null || date.getFullYear() <= 9999) {
            updateRequestPropertyCallBack(requestPropertyName, date);
          }
        }}
        placeholderText="mm/dd/yyyy"
      />
    </div>
  );
};

export const renderAdditionalComments = (updateRequestPropertyCallBack) => {
  return (
    <div className="form-group card-holder quote-change-additional-comments">
      <label>Additional Comments</label>
      <textarea
        placeholder="E.g. Placeholder text"
        onBlur={(e) =>
          updateRequestPropertyCallBack("additionalComments", e.target.value)
        }
      />
    </div>
  );
};

export const renderFile = (request, updateRequestPropertyCallBack) => {
  return (
    <div className="quote-change-file-div">
      <FileComponent
        file={request.file}
        addNewFileCallback={(file) =>
          updateRequestPropertyCallBack("file", file)
        }
        deleteFile={() => updateRequestPropertyCallBack("file", null)}
      />
    </div>
  );
};

export const renderRadioButton = (
  requestPropertyName,
  buttonText,
  request,
  updateRequestPropertyCallBack,
  onClickValue
) => {
  var requestPropertyValue = request[requestPropertyName];
  var value = requestPropertyValue ? requestPropertyValue : false;
  var buttonClass =
    value === onClickValue
      ? "quote-change-radio-button-checked"
      : "quote-change-radio-button";

  return (
    <button
      className={buttonClass}
      onClick={(e) => {
        updateRequestPropertyCallBack(requestPropertyName, onClickValue);
        e.preventDefault();
      }}
    >
      {buttonText}
    </button>
  );
};

export class RenderRadio extends PureComponent {
  componentDidMount() {
    const {
      updateRequestPropertyCallBack,
      requestPropertyName,
      options,
      request,
    } = this.props;

    updateRequestPropertyCallBack(
      requestPropertyName,
      request[requestPropertyName]
        ? request[requestPropertyName]
        : options[0].Value
    );
  }

  render() {
    const {
      name,
      options,
      request,
      requestPropertyName,
      updateRequestPropertyCallBack,
    } = this.props;

    var value = request[requestPropertyName];

    if (!value) {
      value = options[0].Value;
    }

    return (
      <div>
        <label style={{ paddingTop: "10px" }}>{name}</label>
        {options.map((option, idx) => {
          var id = uuid();
          return (
            <div
              className="form-group"
              key={id}
              style={{ width: "100%", height: "50px", marginLeft: "10px" }}
            >
              <table>
                <tr>
                  <td>
                    <input
                      type="radio"
                      value={option.Value}
                      style={{ marginRight: "8px" }}
                      checked={option.Value === value}
                      onChange={() =>
                        updateRequestPropertyCallBack(
                          requestPropertyName,
                          option.Value
                        )
                      }
                    />
                  </td>
                  <td>
                    <label style={{ fontSize: "13px" }}>{option.Name}</label>
                  </td>
                </tr>
              </table>
            </div>
          );
        })}
      </div>
    );
  }
}
